import { render, staticRenderFns } from "./UserIdTypes.vue?vue&type=template&id=9bdc9444&"
import script from "./UserIdTypes.vue?vue&type=script&lang=js&"
export * from "./UserIdTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports